import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material';
import { Router } from '@angular/router';
import swal from 'sweetalert2';
import { Pendencia } from '../models/pendencia';
import { Filtro } from '../models/filtro';
import { CarregandoService } from '../services/carregando.service';
import { NotificacaoService } from '../services/notificacao.service';
import { PaginatorService } from '../services/paginator.service';
import { PendenciaService } from 'src/app/services/pendencia.service';

@Component({
  selector: 'app-pendencia',
  templateUrl: './pendencia.component.html',
  styleUrls: ['./pendencia.component.scss']
})
export class PendenciaComponent implements OnInit {
  // variáveis
  pendenciasFiltradas: Pendencia[] = [];
  carregando = true;
  campoOrdenacao = 'nome';
  ordenarDesc = false;
  editavel = true;
  paginacao: any;
  listaDeItensPorPagina: any;
  itensPorPagina: any;
  filtroNome: Filtro = { Propriedade: 'nome', Valor: '' };
  filtros: Filtro[] = [this.filtroNome];

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  constructor(
    private pendenciaService: PendenciaService,
    private router: Router,
    private paginatorService: PaginatorService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService
  ) {}

  ngOnInit() {
    const pagination = this.paginatorService.consultarPaginacao();

    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.buscarPendencias();
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  filtra() {
    this.buscarPendencias();
    this.paginator.firstPage();
  }

  buscarPendencias() {
    this.carregandoService.mostra('buscaPendencias');
    this.carregando = true;

    this.pendenciaService.consultarPendenciaComPaginacao(
      this.filtroNome.Valor,
      this.paginacao.paginaAtual,
      this.itensPorPagina,
      this.campoOrdenacao,
      this.ordenarDesc ? 'desc' : 'asc')
      .subscribe(dados => {
        this.pendenciasFiltradas = dados.itens;

        if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
          this.itensPorPagina = 10;
        }

        this.paginacao.total = dados.total;

        this.carregando = false;
        this.carregandoService.esconde('buscaPendencias');
      }, (erro) => {
        this.carregandoService.esconde('buscaPendencias');
        this.notificacaoService.erro(erro);
      });
  }

  novaPendencia() {
    this.router.navigate(['/configuracoes/pendencias/novo']);
  }

  editarPendencia(pendencia: Pendencia) {
    this.router.navigate(['/configuracoes/pendencias/editar', pendencia.id]);
  }

  excluirPendencia(pendencia: Pendencia) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente excluir a Pendencia?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('excluiPendencia');
        this.pendenciaService.excluir(pendencia.id).subscribe(resp => {
          this.notificacaoService.sucesso('Pendencia excluída com sucesso!!!');
          this.carregandoService.esconde('excluiPendencia');
          this.filtra();
        }, (erro) => {
          this.carregandoService.esconde('excluiPendencia');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarPendencias();
  }

  ngOnDestroy(): void {}
}
